import { ObjetKForm, requiredRule, combineRules } from '@siclop/kstone-vue'

export class TeamForm extends ObjetKForm {
  code: string = ''
  label: string = ''
  order: number = 0
  description: string = ''
  /** null = selon l'entreprise (ne pas confondre avec false = forcé à « Non »). */
  secondLevelApproval: boolean | null = null

  static validationRules = {
    code: combineRules(requiredRule('Le code est obligatoire')),
    label: combineRules(requiredRule('Le libellé est obligatoire'))
  }

  constructor(data?: Partial<TeamForm>) {
    super(data)
    if (data) {
      this.code = data.code ?? ''
      this.label = data.label ?? ''
      this.order = data.order ?? 0
      this.description = data.description ?? ''
      this.secondLevelApproval = typeof data.secondLevelApproval === 'boolean' ? data.secondLevelApproval : null
    }
  }
}
